import PasswordInput from './PasswordInput'

export default PasswordInput



// WEBPACK FOOTER //
// ./src/app/elements/PasswordInput/index.js